import { ComponentProps } from "react"

import IconButtonBgSvg from "@/assets/textures/icon-button-bg.svg?react"
import IconButtonBorderSvg from "@/assets/textures/icon-button-border.svg?react"

import { cn } from "@/shared/lib/utils"

const ICON_GLOW_CLASS = {
  green: "shadow-[0_0_6px_1px_rgba(0,254,116,0.85)]",
  orange: "shadow-[0_0_6px_1px_rgba(252,210,85,0.85)]",
} as const

const IconButton = ({
  className,
  icon,
  variant = "default",
  ...props
}: ComponentProps<"button"> & {
  icon: React.ReactNode
  variant?: "default" | "green" | "orange"
}) => {
  const isActive = variant !== "default"

  return (
    <button
      type="button"
      className={cn(
        "relative isolate flex size-11 items-center justify-center rounded-full",
        isActive && "z-10",
        className
      )}
      {...props}
    >
      {isActive ? (
        <span
          aria-hidden
          className={cn(
            "pointer-events-none absolute inset-0 rounded-full",
            ICON_GLOW_CLASS[variant]
          )}
        />
      ) : null}
      <IconButtonBgSvg className="absolute inset-0.5 z-[1]" />
      <IconButtonBorderSvg
        className={cn(
          "absolute inset-0 z-[2]",
          variant === "default" && "text-[#9594B3]",
          variant === "green" && "text-green-100",
          variant === "orange" && "text-[#FCD255]"
        )}
      />
      <span className="relative z-[3]">{icon}</span>
    </button>
  )
}

export default IconButton
